import ScriptloaderInstallWizardIframe from 'ui-addon-scriptloader/components/ScriptloaderInstallWizardIframe';
import UIModalPanel from 'UIComponents/dialog/UIModalPanel';
import { jsx as _jsx } from "react/jsx-runtime";
const ScriptloaderInstallModalPanel = ({
  onConfirm,
  onCloseComplete,
  onOpenStart,
  onOpenComplete,
  onReject,
  showStatus,
  installType
}) => {
  return /*#__PURE__*/_jsx(UIModalPanel, {
    onCloseComplete: onCloseComplete,
    onOpenStart: onOpenStart,
    onOpenComplete: onOpenComplete,
    children: /*#__PURE__*/_jsx(ScriptloaderInstallWizardIframe, {
      onConfirm: onConfirm,
      onReject: onReject,
      showStatus: showStatus,
      installType: installType
    })
  }, "uiScriptloader");
};
export default ScriptloaderInstallModalPanel;